<div class="header">
    <div class="header-left">
        <button class="back" [attr.aria-label]="'common.back' | translate" data-test="dialog-select-media-type-back" (click)="goBack()">
            <i class="pi pi-arrow-left"></i>
        </button>
        <h2>{{ 'dialogs.selectMedia.selectType.title' | translate }}</h2>
    </div>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="dialog-select-media-type-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<div class="body">
    <div class="section">
        <h2>{{ 'dialogs.selectMedia.selectType.heading' | translate }}</h2>
        <div class="type-grid">
            @for (type of types; track type.value) {
                <button
                    [class]="'type-card type-card-' + type.value"
                    [attr.data-test]="'dialog-select-media-type-' + type.value"
                    (click)="selectType(type.value)"
                >
                    <i [class]="type.icon"></i>
                    <span>{{ type.label }}</span>
                </button>
            }
        </div>
    </div>
</div>
